var React = require('react');

function TimerOff (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.28 3.413l-1.065 1.065a6.76 6.76 0 0 0-7.928-.368l1.096 1.095A5.233 5.233 0 0 1 8 4.5a5.246 5.246 0 0 1 5.25 5.25c0 .953-.262 1.852-.705 2.617l1.088 1.088a6.722 6.722 0 0 0-.36-7.912l1.065-1.066-1.058-1.065zM10.25.75h-4.5v1.5h4.5V.75zm-3 6.33l1.5 1.5V6h-1.5v1.08zM1.265 3l-.952.953 2.062 2.07A6.679 6.679 0 0 0 1.25 9.75 6.746 6.746 0 0 0 8 16.5c1.38 0 2.662-.413 3.735-1.125l1.875 1.875.953-.953-5.783-5.782L1.265 3zM8 15a5.246 5.246 0 0 1-4.537-7.89l7.17 7.17A5.15 5.15 0 0 1 8 15z","fill":"currentColor","fillRule":"evenodd"}));
}

TimerOff.defaultProps = {"width":"15","height":"18","viewBox":"0 0 15 18"};

module.exports = TimerOff;

TimerOff.default = TimerOff;
